/* eslint-disable consistent-return */
import fetch from 'isomorphic-unfetch';
import config from '../../config';

export const FETCH_AUSTRALIA_TOP_RANKED = 'AUSTRALIA_TOP_RANKED:FETCH';
export const FETCH_AUSTRALIA_TOP_RANKED_SUCCESS = 'AUSTRALIA_TOP_RANKED:FETCH_SUCCESS';

const { apiHost } = config;

export const fetchRankingsData = ({ gender, level, state }) => async (dispatch) => {
    dispatch({ type: FETCH_AUSTRALIA_TOP_RANKED });

    const results = await fetch(`${apiHost}/v2/player/australia/rankings?gender=${gender}&ageGroup=${level}${state && state !== 'ALL' ? `&state=${state}` : ''}`);
    const resultsJson = await results.json();

    const payload = {
        error: (resultsJson.error || null),
        players: (!resultsJson.error ? resultsJson : []),
    };
    dispatch({
        type: FETCH_AUSTRALIA_TOP_RANKED_SUCCESS,
        payload,
    });
};
